import React from 'react'
import IconSVG from 'svg-inline-react'
import Toggle from 'components/Toggle'
import { PremiumTeamGate } from 'components/payments/Gates'
import PremiumOverlay from 'components/shared/PremiumOverlay'
import style from './style.styl'

const BOLT_SRC = require('!svg-inline?removeSVGTagAttrs=false&removeTags=false!images/svg/bolt.svg')

const brandingFeatureText = 'Custom Branding'
const brandingPlan = 'Pro'

const BrandingLink = () => (
  <div className={style.BrandingLink}>
    <h3 className="widget-settings-section-header-title">Show Drift Branding</h3>
    <span className="widget-settings-section-header-desc">
      When this is enabled, Drift branding will be displayed on your Drift Widget, Drift Meetings, Drift
      Profile and your Drift emails.
    </span>
    <div className="flex">
      Chat
      <IconSVG className="flex" src={BOLT_SRC} style={{ margin: '0 0.25rem' }} />
      by
      <a style={{ margin: '0 0.25rem', fontWeight: 500 }}>Drift</a>
    </div>
  </div>
)

const Disabled = (
    <PremiumOverlay className="DriftBrandingContainerDisabled">
      <div className="upgrade-prompt" >
        <div className="flex-space-between">
          <BrandingLink />
        </div>
        <div className="upgrade-prompt-text-container" style={{ margin: "15px", height: "65px", "font-size": "13px" }}>
          <div className="upgrade-prompt-text">To remove Drift</div><div className="upgrade-prompt-text">branding from the</div><div className="upgrade-prompt-text">chat widget…</div>
        </div>
      </div>

        <Toggle checked={true} disabled={true} />
    </PremiumOverlay>
)

const DriftBranding = ({ value, onChange }) => (
  <PremiumTeamGate
    FallbackComponent={Disabled}
    useModal={true}
    modalText={brandingFeatureText}
    modalPlan={brandingPlan}
    feature="drift-branding"
  >
    <div className="flex-space-between">
      <BrandingLink />
      <Toggle defaultChecked={value} onChange={onChange} />
    </div>
  </PremiumTeamGate>
)

export default DriftBranding



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/Styling/DriftBranding/index.js